import {
    DELETED_PAGE,
    FETCH_PAGE,
    FETCHED_PAGES,
    FETCHED_PAGES_TYPES,
    SELECTED_PAGE_TYPE,
    CLOSE_ADD_PAGE_POPUP,
    FETCHED_PAGES_TAGS_BY_PAGE_TYPE,
    SELECTED_PAGE_TAGS_DESTINATION,
    SELECTED_PAGE_TAGS_CONTINENT,
    SELECTED_PAGE_TAGS_TRIP_FORMAT,
    SELECTED_PAGE_TAGS_TYPE_OF_WORK,
    SELECTED_PAGE_TAGS_TYPE_OF_WORK_TAG,
    SELECTED_PAGE_TAGS_TYPE_OF_WORK_GROUP,
    SELECTED_PAGE_TAGS_ALL,
    SELECT_STATUS_CODE,
    UPDATE_REDIRECT_URL,
    CLEAR_REDIRECT_URL,
    CLEAR_STATUS_CODE,
    HAS_ERROR,
    PUBLISHED_PAGE,
    UNPUBLISHED_PAGE,
    UPDATE_TRANSLATION_SITE,
    CLEAR_TRANSLATION_SITE,
    FETCHED_EXISTING_PAGE_TRANSLATIONS,
    FETCHED_MISSING_PAGE_TRANSLATIONS,
    UPDATE_ADD_TRANSLATION_SITES,
    CLEAR_ADD_TRANSLATION_SITES, SELECT_ALL_ADD_TRANSLATION_SITES
} from './types';

export function hasError(field, metaError){
    return {
        type: HAS_ERROR,
        payload: {
            field: field,
            metaError: metaError
        }
    }
}

export function fetchedPages(data, totalPages) {
    return {
        type: FETCHED_PAGES,
        payload: {
            data: data,
            totalPages: totalPages,
            loading: false
        }
    }
}

export function fetchedPageTypes(pageTypes) {
    return {
        type: FETCHED_PAGES_TYPES,
        pageTypes
    }
}

export function fetchedPage(response) {
    return {
        type: FETCH_PAGE,
        payload: response
    };
}

export function deletedPage(pageId) {
    return {
        type: DELETED_PAGE,
        pageId
    }
}

export function selectPageType(selectedPageType) {
    return {
        type: SELECTED_PAGE_TYPE,
        selectedPageType
    }
}

export function fetchedPageTagsByPageType(tagsByPageType) {
    return {
        type: FETCHED_PAGES_TAGS_BY_PAGE_TYPE,
        tagsByPageType
    }
}

export function selectPageTagsDestination(selectedPageTagsDestination, tagsKey) {

    let selectedTags = (selectedPageTagsDestination !== undefined && selectedPageTagsDestination instanceof Array
    ) ? selectedPageTagsDestination : [selectedPageTagsDestination];

    return {
        type: SELECTED_PAGE_TAGS_DESTINATION,
        selectedTags,
        tagsKey,
    }
}

export function selectPageTagsContinent(selectedPageTagsContinent, tagsKey) {

    let selectedTags = (selectedPageTagsContinent !== undefined && selectedPageTagsContinent instanceof Array
    ) ? selectedPageTagsContinent : [selectedPageTagsContinent];

    return {
        type: SELECTED_PAGE_TAGS_CONTINENT,
        selectedTags,
        tagsKey,
    }
}

export function selectPageTagsTripFormat(selectedPageTagsTripFormat, tagsKey) {

    let selectedTags = (selectedPageTagsTripFormat !== undefined && selectedPageTagsTripFormat instanceof Array
    ) ? selectedPageTagsTripFormat : [selectedPageTagsTripFormat];

    return {
        type: SELECTED_PAGE_TAGS_TRIP_FORMAT,
        selectedTags,
        tagsKey,
    }
}

export function selectPageTagsTypeOfWork(selectedPageTagsTypeOfWork, tagsKey) {

    let selectedTags = (selectedPageTagsTypeOfWork !== undefined && selectedPageTagsTypeOfWork instanceof Array
    ) ? selectedPageTagsTypeOfWork : [selectedPageTagsTypeOfWork];

    return {
        type: SELECTED_PAGE_TAGS_TYPE_OF_WORK,
        selectedTags,
        tagsKey,
    }
}

export function selectPageTagsTypeOfWorkTag(selectedPageTagsTypeOfWorkTag, tagsKey) {

    let selectedTags = (selectedPageTagsTypeOfWorkTag !== undefined && selectedPageTagsTypeOfWorkTag instanceof Array
    ) ? selectedPageTagsTypeOfWorkTag : [selectedPageTagsTypeOfWorkTag];

    return {
        type: SELECTED_PAGE_TAGS_TYPE_OF_WORK_TAG,
        selectedTags,
        tagsKey,
    }
}

export function selectPageTagsTypeOfWorkGroup(selectedPageTagsTypeOfWorkGroup, tagsKey) {

    let selectedTags = (selectedPageTagsTypeOfWorkGroup !== undefined && selectedPageTagsTypeOfWorkGroup instanceof Array
    ) ? selectedPageTagsTypeOfWorkGroup : [selectedPageTagsTypeOfWorkGroup];

    return {
        type: SELECTED_PAGE_TAGS_TYPE_OF_WORK_GROUP,
        selectedTags,
        tagsKey,
    }
}

export function selectPageTagsAll(selectedPageTagsAll, tagsKey) {

    let selectedTags = (selectedPageTagsAll !== undefined && selectedPageTagsAll instanceof Array
    ) ? selectedPageTagsAll : [selectedPageTagsAll];

    return {
        type: SELECTED_PAGE_TAGS_ALL,
        selectedTags,
        tagsKey,
    }
}

export function closeAddPagePopup() {
    return {
        type: CLOSE_ADD_PAGE_POPUP,
    }
}

export function selectStatusCode(selectedStatus) {
    return {
        type: SELECT_STATUS_CODE,
        selectedStatus
    }
}

export function updateRedirectUrl(redirectUrl) {
    return {
        type: UPDATE_REDIRECT_URL,
        redirectUrl
    }
}

export function clearRedirectUrl() {
    return {
        type: CLEAR_REDIRECT_URL,
    }
}

export function clearStatusCode() {
    return {
        type: CLEAR_STATUS_CODE,
    }
}

export function publishedPage(pageId) {
    return {
        type: PUBLISHED_PAGE,
        pageId
    }
}

export function unpublishedPage(pageId) {
    return {
        type: UNPUBLISHED_PAGE,
        pageId
    }
}

export function fetchedExistingPageTranslations(existingPageTranslations) {
    return {
        type: FETCHED_EXISTING_PAGE_TRANSLATIONS,
        existingPageTranslations
    }
}

export function fetchedMissingPageTranslations(missingPageTranslations) {
    return {
        type: FETCHED_MISSING_PAGE_TRANSLATIONS,
        payload: {
            missingPageTranslations: missingPageTranslations
        }
    }
}

export function updateTranslationSite(selectedSite) {
    return {
        type: UPDATE_TRANSLATION_SITE,
        selectedSite
    }
}

export function updateAddTranslationSites(updatedSite) {
    return {
        type: UPDATE_ADD_TRANSLATION_SITES,
        payload: {
            updatedSite: updatedSite
        }
    }
}

export function clearTranslationSite() {
    return {
        type: CLEAR_TRANSLATION_SITE,
    }
}

export function clearAddTranslationSites() {
    return {
        type: CLEAR_ADD_TRANSLATION_SITES,
    }
}

export function selectAllAddTranslationSites() {
    return {
        type: SELECT_ALL_ADD_TRANSLATION_SITES,
    }
}


// WEBPACK FOOTER //
// ./src/containers/pages/actions.js